import { render, staticRenderFns } from "./FormNuovaPassword.vue?vue&type=template&id=62b034b2&scoped=true"
import script from "./FormNuovaPassword.vue?vue&type=script&lang=js"
export * from "./FormNuovaPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b034b2",
  null
  
)

export default component.exports